// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wh1Cs","colMin":"styles_colMin__1D39u"};